<template>
    <b-container fluid class="position-relative ps-0">

        <b-row class="suppaymentdetailsscreen">
            <b-col xxl="2" xl="2" lg="3" md="4" sm="6" cols="12" class="staticleftsidebar">
                <LeftBar masterheading="Supplier Payment" pagename="SupplierPaymentDetails" :storestatus="false"
                    :listed="sidebardata" v-model="datas"></LeftBar>
                <a class="back-btn" @click="goback">
                    <img alt="Vue logo" class="back" src="../../../../../../assets/Img/icons/backtoright.svg"
                        width="125" height="125" />
                </a>
            </b-col>
            <b-col xxl="10" xl="10" lg="9" md="8" sm="6" cols="12">
                <b-container fluid>
                    <ApprovalConfirmation v-if="ApprovalListchange.length != 0 &&
                        ApprovalListchange.some(item => item['IsApproved'] == 0)
                    " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @Approve="Approve"
                        :SuccessfullPopUp="SuccessfullPopUp" @triggerDetails="triggerDetails()" />
                    <ApprovalStatus v-if="ApprovalList.length != 0" :ApprovalgetList="ApprovalList"
                        :approvaldetails="approvaldetails" />
                    <b-row>
                        <b-col class="my-3">
                            <div class="supplierdetails_card">
                                <div class="supplierdetails_card_header">
                                    <h2>Supplier Details</h2>
                                </div>
                                <div class="supplierdetails_card_body">
                                    <div class="supplier_data_list">
                                        <span>Supplier Name :</span>
                                        <span>{{ datas.Name }}</span>
                                    </div>
                                    <div class="supplier_data_list">
                                        <span>Supplier ID :</span>
                                        <span>{{ datas.Code }}</span>
                                    </div>
                                    <div class="supplier_data_list">
                                        <span>Phone Number :</span>
                                        <span>{{ datas.PhoneNo }}</span>
                                    </div>
                                    <div class="supplier_data_list">
                                        <span>Mail :</span>
                                        <span>{{ datas.EmailId }}</span>
                                    </div>
                                    <div class="supplier_data_list">
                                        <span>GST Number :</span>
                                        <span>{{ datas.GSTNO }}</span>
                                    </div>
                                    <div class="supplier_data_list">
                                        <span>Total Outstanding :</span>
                                        <span><i>&#8377</i>{{ datas.TotalOutstanding }}</span>
                                    </div>
                                    <!-- <div class="supplier_data_list">
                                            <span>Total Invoices :</span>
                                            <span>{{datas.TotalInvoiceNo}}</span>
                                        </div> -->
                                    <!-- <div class="supplier_data_list">
                                            <span>Total Debit Notes :</span>
                                            <span>{{datas.TotalDebitNotes}}</span>
                                        </div> -->
                                    <!-- <div class="supplier_data_list">
                                            <span>Total Debit Note Value :</span>
                                            <span><i>&#8377</i>{{datas.DebitValues}}</span>
                                        </div> -->
                                    <!-- <div class="supplier_data_list">
                                            <span>Prepayments :</span>
                                            <span> <i>&#8377</i> {{datas.Prepayment}}</span>
                                        </div> -->
                                    <!-- <div class="supplier_data_list">
                                            <span>Payment Terms :</span>
                                            <span>{{datas.PaymentTerm}}</span>
                                        </div> -->
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col class="supplierpayments_tabs">
                            <TabView class="tabview-custom transaction-tabs" :scrollable="true"
                                v-model:activeIndex="activeTabIndex" @tabChange="onTabChange">
                                <TabPanel>
                                    <template #header>
                                        <span> Outstanding Invoices</span>
                                    </template>
                                    <div>
                                        <OutStandingInoviceTable :datas="datas" :activeIndex="activeTabIndex"
                                            @loadactiveindex="increaseactiveindex"
                                            @invoiceselection="invoiceselection" />
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <template #header>
                                        <span> Payment Details </span>
                                    </template>
                                    <div>
                                        <PaymentAdjustmentTableView :datas="datas" :activeIndex="activeTabIndex"
                                            :invoicedata="updateinvoiceselection" :prepaymentdata="updateprepaymentdata"
                                            @loadactiveindex="increaseactiveindex" />
                                    </div>
                                </TabPanel>

                                <!-- <TabPanel>
                                    <template #header>
                                        <span> Debit Notes</span>
                                    </template>
                                    <div>
                                        <ActiveDebitNotesTableView :activeIndex="activeTabIndex" :datas="datas" />
                                    </div>
                                </TabPanel> -->
                                <!-- <TabPanel>
                                    <template #header>
                                        <span> Prepayments</span>
                                    </template>
                                    <div>
                                        <ActivePrePaymentTableView :activeIndex="activeTabIndex" :datas="datas"
                                            :showprepayadjustment="false" @updatedprepayment="prepaymentisshow"
                                            @ApprovalDetailsData="ApprovalDetailsData"
                                            :PrePaymetStatus="PrePaymetStatus" />
                                    </div>
                                </TabPanel> -->
                                <TabPanel>
                                    <template #header>
                                        <span> PO Payments</span>
                                    </template>
                                    <div>
                                        <POPaymentsTableView :activeIndex="activeTabIndex"
                                            @loadactiveindex="increaseactiveindex" />
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <template #header>
                                        <span> Invoice Payments</span>
                                    </template>
                                    <div>
                                        <InvoicePaymentsTableView :activeIndex="activeTabIndex"
                                            @loadactiveindex="increaseactiveindex" />
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <template #header>
                                        <span> Payment History </span>
                                    </template>
                                    <div>
                                        <PaymentHistoryTableView :datas="datas" :activeIndex="activeTabIndex"
                                            :IsApprovalStatus="IsApprovalStatus"
                                            @ApprovalDetailsData="ApprovalDetailsData" />
                                    </div>
                                </TabPanel>

                            </TabView>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import OutStandingInoviceTable from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/OutStandingInvoicesTableView.vue"
import POPaymentsTableView from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/POPaymentsTableView.vue"
import InvoicePaymentsTableView from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/InvoicePaymentsTableView.vue"
import ActiveDebitNotesTableView from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/ActiveDebitNotesTableView.vue"
import ActivePrePaymentTableView from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/ActivePrePaymentTableView.vue"
import PaymentHistoryTableView from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/PaymentHistoryTableView.vue"
import PaymentAdjustmentTableView from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/PaymentAdjustmentTableView.vue"
import PaymentDetailsScreen from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/PaymentDetailsScreen.vue"
import SupplierPaymentService from "../../../../../../modules/Inventory/Service/SupplierPrePayment";
import PoApprovalService from "../../../../../../modules/Inventory/Service/PoApprovalService";
// import Payment from '../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/SupplierPaymentTable.vue';
import ApprovalConfirmation from "../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../components/FormComponents/ApprovalStatus.vue";
import moment from "moment";
import SupplierPaymentMasterService from "../../../../../../modules/Inventory/Service/SupplierPaymentMasterService"

export default defineComponent({
    components: {
        LeftBar,
        Headerlayout,
        OutStandingInoviceTable,
        POPaymentsTableView,
        InvoicePaymentsTableView,
        ActiveDebitNotesTableView,
        ActivePrePaymentTableView,
        PaymentHistoryTableView,
        PaymentAdjustmentTableView,
        PaymentDetailsScreen,
        ApprovalConfirmation,
        ApprovalStatus,
    },
    props: {
        showDetailsTab: {
            readonly: false,
            type: Boolean,
            default: false,
        },
        showItemsTab: {
            readonly: false,
            type: Boolean,
            default: false,
        },
    },
    setup(emit) {
        const datas: any = ref([]);
        const loading = ref(false);
        const route = useRoute();
        const router = useRouter();
        const activeTabIndex = ref(0);
        const updateinvoiceselection = ref([]);
        const updateprepaymentdata = ref([]);
        //get local storage session data
        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }
        //
        const sidebardata = ref([]);
        let DeptRoleMapId = Number(rolesData.DeptRoleMapId);
        const paramValues = ref({
            Id: "",
        });
        let IsApprovalStatus = ref(false)
        let PrePaymetStatus = ref(false)
        let ApprovalList = ref([]);
        let ApprovalListchange = ref([]);
        let approvaldetails: any = ref({
            HeaderName: "Supplier Payment",
            ContentName: "Supplier Payment",
            ApprovalCode: 0,
            ApprovalDate: "",
            ApprovalPrice: 0,
            CreatedAt: "",
        });
        let SuccessfullPopUp = ref({
            accept: ref(false),
            decline: ref(false),
        });
        watch(
            () => route.query.Id,
            (newVal: any) => {
                debugger;
                paramValues.value.Id = newVal;
                route.query.Id = newVal;
            }
        );
        onMounted(() => {
            paramValues.value.Id = String(route.query.Id);
            IsShow();
        });

        const paramValue = computed(() => {
            return route.query.param as string;
        });


        async function IsShow() {
            debugger;
            debugger;
            try {
                loading.value = true;
                let count = 0;
                const dataresponse = await SupplierPaymentService.GetSupplierDetailsList(usersData.OrganizationId, usersData.BranchId, Number(route.query.StoreBranchMapId));
                sidebardata.value = dataresponse["result"].map((item: any) => {
                    count = count + 1;
                    item.RowNumber = count;
                    return item;
                });

                let obj = sidebardata.value.filter(
                    (items) => items["SupplierId"] == paramValues.value.Id
                );

                console.log(obj[0]);

                datas.value = obj[0];
                loading.value = false;
            } catch (error) {
                console.log(error);
            }
        }

        const goback = () => {
            setupHistoryManagement(router, 5);
        };
        // Handle tab change (if needed for some logic)
        const onTabChange = (event: any) => {

            activeTabIndex.value = event.index;
        };
        const increaseactiveindex = () => {
            activeTabIndex.value += 1;
        };
        watch(() => activeTabIndex.value,
            (newVal: any) => {
                activeTabIndex.value = newVal;
                PaymentID.value = 0
                ApprovalListchange.value = []
                ApprovalList.value = []
                if (activeTabIndex.value == 0) {
                    IsShow()
                }
            }
        );
        let PaymentID = ref(0)
        let ApprovalType = ref(0)
        const invoiceselection = (data: any) => {
            updateinvoiceselection.value = data;
        };
        const prepaymentisshow = (data: any) => {
            updateprepaymentdata.value = data;
        };
        function ApprovalDetailsData(data) {
            debugger
            if (data.ApprovalStatus == 0) {
                PaymentID.value = data.PaymentID
                ApprovalType.value = data.ApprovalType
                if (ApprovalType.value == 1) {
                    approvaldetails.value.HeaderName = "Supplier Payment"
                    approvaldetails.value.ContentName = "Supplier Payment"
                    approvaldetails.value.ApprovalCode = data.PaymentCode
                    approvaldetails.value.ApprovalDate = data.PaymentDate
                    approvaldetails.value.ApprovalPrice = data.PaymentAmount
                }
                else if (ApprovalType.value == 2) {
                    approvaldetails.value.HeaderName = "Supplier PrePayment"
                    approvaldetails.value.ContentName = "Supplier PrePayment"
                    approvaldetails.value.ApprovalCode = data.Code
                    approvaldetails.value.ApprovalDate = data.PaymentDate
                    approvaldetails.value.ApprovalPrice = data.Amount
                }
                getApprovaldata()
            }
            else {
                PaymentID.value = 0
                ApprovalListchange.value = []
                ApprovalList.value = []
            }

        }
        async function getApprovaldata() {
            debugger;
            try {
                let response = await PoApprovalService.GetPOApprovalList(
                    PaymentID.value,
                    usersData.OrganizationId,
                    usersData.BranchId,
                    ApprovalType.value == 1 ? 416 : 417
                );
                ApprovalList.value = response["result"];
                ApprovalListchange.value = response["result"].filter(
                    (item) => item.DepRoleID == DeptRoleMapId
                );
                console.log("approval data", ApprovalList.value);
            } catch (error) {
                console.log(error);
            }
        }
        let isForm = ref({
            EntityOperationId: 0,
            Id: 0,
            EntityApprovalMapID: 0,
            EntityTransactionId: 0,
            ApproverID: usersData.UserId,
            DepRoleID: rolesData.DeptRoleMapId,
            IsApproved: 0,
            ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            Remarks: "",
            EntityId: 0
        });
        async function Approve(Values) {
            debugger;
            try {
                let rowToAssign = null;
                for (let i = 0; i < ApprovalListchange.value.length; i++) {
                    if (ApprovalListchange.value[i]["IsApproved"] === 0) {
                        rowToAssign = ApprovalListchange.value[i];
                        break;
                    }
                }
                if (rowToAssign) {
                    isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
                    isForm.value.Id = rowToAssign["ID"];
                    isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];
                    isForm.value.IsApproved = Values.Approvalstatus;
                    isForm.value.Remarks = Values.Remarks;
                    isForm.value.EntityId = rowToAssign["EntityId"];
                }
                let response;
                if (isForm.value.IsApproved == 1) {
                    response = await PoApprovalService.POApproval(isForm.value);
                    if (response["ErrorInfo"].ErrorCode == null) {
                        if (response["result"] == 1) {
                            UpdateApprovalStatus(isForm.value.EntityTransactionId, ApprovalType.value);
                        }

                    } else {
                        alert("Somthing went wrong");
                    }
                } else if (isForm.value.IsApproved == 3) {
                    response = await PoApprovalService.POReject(isForm.value);
                    if (response["ErrorInfo"].ErrorCode == null) {
                        UpdateApprovalStatus(isForm.value.EntityTransactionId, ApprovalType.value);
                        SuccessfullPopUp.value.decline = true;
                    } else {
                        alert("Somthing went wrong");
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
        async function UpdateApprovalStatus(Id, Type) {
            debugger;
            try {
                let response: any
                //SupplierPaymentMaster
                if (Type == 1) {
                    response = await SupplierPaymentMasterService.UpdateApprovalStatus(
                        Id,
                        isForm.value.IsApproved
                    );
                }
                //SupplierPrePaymentMaster
                else if (Type == 2) {
                    response = await SupplierPaymentService.UpdateApprovalStatus(
                        Id,
                        isForm.value.IsApproved
                    );
                }
                let message = response["ErrorInfo"].ErrorCode;
                if (message == null) {
                    SuccessfullPopUp.value.accept = true;
                }
            } catch (error) {
                console.log(error);
            }
        }
        function triggerDetails() {
            getApprovaldata()
            if (ApprovalType.value == 1) {
                IsApprovalStatus.value = !IsApprovalStatus.value
            }
            else if (ApprovalType.value == 2) {
                PrePaymetStatus.value = !PrePaymetStatus.value
            }
            PaymentID.value = 0
            SuccessfullPopUp.value.accept = false;
            SuccessfullPopUp.value.decline = false;
        }
        return {
            sidebardata,
            paramValue,
            datas,
            paramValues,
            loading,
            goback,
            activeTabIndex,
            onTabChange,
            increaseactiveindex,
            invoiceselection,
            updateinvoiceselection,
            prepaymentisshow,
            updateprepaymentdata,
            ApprovalDetailsData,
            getApprovaldata,
            ApprovalListchange,
            UpdateApprovalStatus,
            approvaldetails,
            Approve,
            SuccessfullPopUp,
            ApprovalList,
            IsApprovalStatus,
            PrePaymetStatus,
            triggerDetails

        };
    },
});
</script>

<style lang="scss">
.p-tabview-header span {
    white-space: nowrap;
}

.tabview-custom {
    width: 99%;
}

.staticleftsidebar {
    position: sticky !important;
    top: 0;
}

.supplierpayments_tabs .p-tabview-panels {
    min-height: 60vh;
    max-height: 75vh;
    overflow: auto;
}

.supplierpayments_tabs .p-tabview-panels::-webkit-scrollbar {
    display: none;
}

.supplierdetails_card {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 8px;
    padding: 15px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    .supplierdetails_card_header {
        margin-bottom: 15px;
    }

    .supplierdetails_card_header h2 {
        font-size: 16px;
        margin: 0;
    }

    .supplierdetails_card_body {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
    }

    .supplier_data_list {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 280px;
        margin-right: 15px;
        margin-bottom: 10px;
        font-size: 14px;
    }

    span:nth-child(1) {
        display: block;
        font-weight: 500;
        color: #444444;
        max-width: 150px;
        min-width: max-content;
    }

    span:nth-child(2) {
        color: #999999;
        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

}

.suppaymentdetailsscreen .back-btn {
    background-color: #0148e2;
    border-radius: 50%;
    height: 35px;
    width: 35px;
    position: fixed;
    top: 20%;
    left: 13.5%;
    z-index: 1000;
}
</style>